import axios from 'axios'
import Vue from 'vue'
export default {
	namespaced: true,
	state: {
		filtro: {
			EmisoraID: null,
			dia: Math.round(new Date().getTime() / 1000),
			buscaInsercion: ''
		},
		parrilla: [],
		insercionActiva: null,
		seleccionInserciones: [],
		bloques: [],
		bloqueActivo: null,
		seleccionBloques: [],
		buzonesFavoritos: [],
		buzonFavorito: null,
		ficherosFavoritos: [],
		seleccionFavoritos: [],
		omitirBloquesSinMatricula: true,
		reproducir: null,
		xfavoritos: {
			buzones: [],
			ficheros: [],
			seleccion: [],
			buzonActivo: null
		},
		xbloques: {
			listado: [],
			bloqueActivo: null,
			omitirSinMatricula: true,
			insercionesEncontradas: []
		},
		xparrilla: {
			inserciones: [],
			seleccion: []
		}
	},
	getters: {
		// Filtro
		EmisoraID (state) {
			return state.filtro.EmisoraID
		},
		dia (state) {
			return state.filtro.dia
		},

		// Favoritos
		buzonesFavoritos (state) {
			return state.xfavoritos.buzones
		},
		ficherosFavoritos (state) {
			return state.xfavoritos.ficheros
		},
		seleccionFavoritos (state) {
			return state.xfavoritos.seleccion
		},
		buzonActivoFavoritos (state) {
			return state.xfavoritos.buzonActivo
		},

		// Bloques
		listadoBloques (state) {
			return state.xbloques.listado.filter(b => (!state.xbloques.omitirSinMatricula || b.BloqueMatricula)).map(b => {
				if (state.xbloques.insercionesEncontradas.map(blo => blo.BloqueID).indexOf(b.BloqueID) >= 0) {
					b.insercionesEncontradas = true
				} else {
					b.insercionesEncontradas = false
				}
				return b
			})
		},
		bloqueActivo (state) {
			return state.xbloques.bloqueActivo
		},
		omitirBloquesSinMatricula (state) {
			return state.xbloques.omitirSinMatricula
		},
		insercionesBuscadas (state) {
			return state.xbloques.insercionesBuscadas
		},

		// Parrilla
		insercionesParrilla (state) {
			return state.xparrilla.inserciones
		},
		seleccionInserciones (state) {
			return state.xparrilla.seleccion
		},

		// OLD
		bloques (state) {
			return state.bloques.filter(b => (!state.omitirBloquesSinMatricula || b.BloqueMatricula))
		}
	},
	mutations: {
		// Filtro
		SET_FILTRO (state, data) {
			state.filtro = Object.assign({}, state.filtro, data)
		},
		// Favoritos
		SET_BUZONES_FAVORITOS (state, data) {
			state.xfavoritos.buzones = data
		},
		SET_BUZON_FAVORITO_ACTIVO (state, data) {
			state.xfavoritos.buzonActivo = data
			state.xfavoritos.seleccion = []
			state.xfavoritos.ficheros = []
		},
		SET_FICHEROS_FAVORITOS (state, data) {
			state.xfavoritos.ficheros = data
		},
		BORRA_SELECCION_FAVORITOS (state) {
			state.xfavoritos.seleccion = []
		},
		SELECCIONA_FAVORITO (state, data) {
			const fichero = data.fichero
			const ctrl = data.ctrl || false
			const shift = data.shift || false
			// Si no estamos pulsando ni control ni shift, solo seleccionamos
			// el objeto que se ha clicado
			if ((!ctrl && !shift) || state.xfavoritos.seleccion.length === 0) {
				state.xfavoritos.seleccion = [fichero]
			} else if (ctrl) {
				// Si el fichero ya está seleccionado lo desseleccionamos
				state.xfavoritos.seleccion = state.xfavoritos.ficheros.filter(f => {
					return (
						(state.xfavoritos.seleccion.indexOf(f) >= 0 && f.ObjetoID !== fichero.ObjetoID) ||
						(state.xfavoritos.seleccion.indexOf(f) < 0 && f.ObjetoID === fichero.ObjetoID)
					)
				})
			} else if (shift) {
				// Seleccionamos desde el primer fichero seleccionado hasta el que acaba de clicar
				// Primero hay que ver cual es el elemento con menor índice seleccionado
				let i = null
				for (let f = 0; f < state.xfavoritos.seleccion.length; f++) {
					const idx = state.xfavoritos.ficheros.indexOf(state.xfavoritos.seleccion[f])
					if (idx >= 0) {
						i = (i === null || i > idx) ? idx : i
					}
				}

				// Ya tenemos el elemento con menor índice, ahora vamos a ver cual es el indice del elemento que hemos seleccionado
				const o = state.xfavoritos.ficheros.indexOf(fichero)
				const primero = (i <= o) ? i : o
				const segundo = (i >= o) ? i : o
				state.xfavoritos.seleccion = state.xfavoritos.ficheros.filter((f, i) => (i >= primero && i <= segundo))
			}
		},

		// Bloques
		SET_LISTADO_BLOQUES (state, data) {
			state.xbloques.listado = data
		},
		// Actualiza la información de un bloque
		ACTUALIZA_BLOQUE (state, data) {
			if (state.xbloques.bloqueActivo.BloqueID === data.BloqueID) {
				state.xbloques.bloqueActivo = data
			}
			for (let i = 0; i < state.xbloques.listado.length; i++) {
				if (state.xbloques.listado[i].BloqueID === data.BloqueID) {
					Vue.set(state.xbloques.listado, i, data)
					return
				}
			}
		},
		SET_BLOQUE_ACTIVO (state, data) {
			state.xbloques.bloqueActivo = data
		},
		TOGGLE_SIN_MATRICULA (state, estado) {
			state.xbloques.omitirSinMatricula = !state.xbloques.omitirSinMatricula
		},
		SET_INSERCIONES_ENCONTRADAS (state, listado) {
			state.xbloques.insercionesEncontradas = listado
		},

		// Parrilla
		SET_INSERCIONES_PARRILLA (state, data) {
			state.xparrilla.inserciones = data
		},
		BORRA_SELECCION_INSERCIONES (state) {
			state.xparrilla.seleccion = []
		},
		SELECCIONA_INSERCION (state, data) {
			const insercion = data.insercion
			const ctrl = data.ctrl
			const shift = data.shift

			// Si no estamos pulsando ni control ni shift, solo seleccionamos
			// el objeto que se ha clicado
			if ((!ctrl && !shift) || state.xparrilla.seleccion.length === 0) {
				state.xparrilla.seleccion = [insercion]
			} else if (ctrl) {
				// Si el fichero ya está seleccionado lo desseleccionamos
				state.xparrilla.seleccion = state.xparrilla.inserciones.filter(f => {
					return (
						(state.xparrilla.seleccion.indexOf(f) >= 0 && f.ProgramacionID !== insercion.ProgramacionID) ||
						(state.xparrilla.seleccion.indexOf(f) < 0 && f.ProgramacionID === insercion.ProgramacionID)
					)
				})
			} else if (shift) {
				// Seleccionamos desde el primer fichero seleccionado hasta el que acaba de clicar
				// Primero hay que ver cual es el elemento con menor índice seleccionado
				let i = null
				for (let f = 0; f < state.xparrilla.seleccion.length; f++) {
					const idx = state.xparrilla.inserciones.indexOf(state.xparrilla.seleccion[f])
					if (idx >= 0) {
						i = (i === null || i > idx) ? idx : i
					}
				}

				// Ya tenemos el elemento con menor índice, ahora vamos a ver cual es el indice del elemento que hemos seleccionado
				const o = state.xparrilla.inserciones.indexOf(insercion)
				const primero = (i <= o) ? i : o
				const segundo = (i >= o) ? i : o
				state.xparrilla.seleccion = state.xparrilla.inserciones.filter((f, i) => (i >= primero && i <= segundo))
			}
		},

		// Reproducir
		REPRODUCIR (state, data) {
			state.reproducir = data
		}
	},
	actions: {
		// Filtro
		setFiltro (context, data) {
			// Actualizamos el filtro y realizamos las consultas de todos los endpoints relacionados
			context.commit('SET_FILTRO', data)

			if (context.state.filtro.dia && context.state.filtro.EmisoraID) {
				// Disparamos las consultas
				context.dispatch('getBloques')
			}
		},

		// Favoritos
		getBuzonesFavoritos (context, filtro) {
			axios.get('organizar-emisoras/php/api/favoritos/get-buzones.php')
				.then(res => {
					context.commit('SET_BUZONES_FAVORITOS', res.data.listado)
				})
				.catch(e => {
					this.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: 'Error descargando los buzones de favoritos'
					})
				})
		},
		seleccionaBuzonFavorito (context, buzon) {
			context.commit('SET_BUZON_FAVORITO_ACTIVO', buzon)
			// Obtenemos sus ficheros
			axios.get('organizar-emisoras/php/api/favoritos/get-ficheros.php?ID_buzon=' + buzon.ID_buzon)
				.then(res => {
					context.commit('SET_FICHEROS_FAVORITOS', res.data.listado)
				})
				.catch(e => {
					this.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: 'Error seleccionando el buzón de favoritos'
					})
				})
		},
		// Crea o modifica un buzón de favoritos
		setBuzonFavorito (context, data) {
			axios.post('organizar-emisoras/php/api/favoritos/' + data.url, data.buzon)
				.then(() => {
					context.dispatch('getBuzonesFavoritos')
				})
				.catch(e => {
					this.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: 'Error guardando el buzón'
					})
				})
		},
		// Elimina un buzón de favoritos y todos sus elementos dependientes (sub-buzones y ficheros)
		delBuzonFavorito (context, data) {
			axios.delete('organizar-emisoras/php/api/favoritos/del-buzon.php?ID_buzon=' + data.ID_buzon)
				.then(res => {
					context.dispatch('getBuzonesFavoritos')
				})
				.catch(e => {
					this.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: 'Error eliminando el buzón'
					})
				})
		},
		// Añade ficheros a un buzón de favoritos
		addFicherosFavoritos (context, data) {
			const datos = {
				ID_buzon: context.state.xfavoritos.buzonActivo.ID_buzon,
				objetos: data.map(o => o.ObjetoID)
			}
			axios.post('organizar-emisoras/php/api/favoritos/add-objetos.php', datos)
				.then(res => {
					context.commit('SET_FICHEROS_FAVORITOS', res.data.listado)
				})
				.catch(e => {
					this.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: 'Error agregando los favoritos'
					})
				})
		},
		// Elimina ficheros de un buzón de favoritos
		delFicherosFavoritos (context, data) {
			axios.post('organizar-emisoras/php/api/favoritos/del-favoritos.php', data)
				.then(res => {
					const favs = context.getters.ficherosFavoritos.filter(f => (data.indexOf(f.ID_favorito) < 0))
					context.commit('SET_FICHEROS_FAVORITOS', favs)
				})
				.catch(e => {
					this.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},

		// Bloques
		// Obtiene un listado de bloques en función del las opciones de filtrado
		getBloques (context, data) {
			axios.post('organizar-emisoras/php/api/get-listado-bloques.php', context.state.filtro)
				.then(res => {
					if (Array.isArray(res.data.listado) && res.data.listado.length > 0) {
						context.commit('SET_LISTADO_BLOQUES', res.data.listado)
						// TODO: Comprobar que el bloque seleccionado existe en este listado y recargar su parrilla
					} else {
						context.commit('SET_LISTADO_BLOQUES', [])
						context.commit('SET_INSERCIONES_PARRILLA', [])
					}
					context.dispatch('buscarInserciones')
				})
				.catch(e => {
					this.commit('alertas/error', {
						titulo: 'Error',
						mensaje: 'Error obteniendo los bloques'
					})
				})
		},
		seleccionaBloque (context, data) {
			context.commit('SET_BLOQUE_ACTIVO', data)
			// Ahora obtenemos la parrilla
			context.dispatch('getParrilla')
		},

		buscarInserciones (context) {
			if (!context.state.filtro.buscaInsercion) {
				context.commit('SET_INSERCIONES_ENCONTRADAS', [])
				return
			}

			axios.post('organizar-emisoras/php/api/buscar-inserciones.php', context.state.filtro)
				.then(res => {
					context.commit('SET_INSERCIONES_ENCONTRADAS', res.data.listado)
				})
				.catch(e => {
					this.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: 'Error buscando las inserciones'
					})
				})
		},

		// Parrilla
		getParrilla (context) {
			if (!context.getters.bloqueActivo) {
				return
			}
			const filtro = {
				EmisoraID: context.state.filtro.EmisoraID,
				dia: context.state.filtro.dia,
				BloqueID: context.state.xbloques.bloqueActivo.BloqueID
			}
			axios.post('organizar-emisoras/php/api/get-parrilla-bloque.php', filtro)
				.then(res => {
					context.commit('SET_INSERCIONES_PARRILLA', res.data.parrilla)
				})
				.catch(e => {
					this.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: 'Error consultando la parrilla'
					})
				})
		},
		// Programa inserciones en la parrilla activa
		programarInserciones (context, data) {
			/*
				Necesitamos:
					- Array de ObjetoID
					- Posicion (inicial) en la parrilla
					- BloqueID
					- fecha (en formato unix time)
			*/

			if (!Array.isArray(data.ficheros) || data.ficheros.length === 0) {
				this.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'No has definido ningún objeto a programar'
				})
				return
			}

			if (typeof data.posicion !== 'number' || data.posicion <= 0) {
				this.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'La posición debe ser un número entero superior a 0'
				})
				return
			}

			if (typeof context.state.filtro.dia !== 'number') {
				this.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'Debes definir una fecha válida'
				})
				return
			}

			data.dia = context.state.filtro.dia
			data.BloqueID = context.getters.bloqueActivo.BloqueID

			axios.post('organizar-emisoras/php/api/programar-objetos.php', data)
				.then(res => {
					// Actualizamos el estado del bloque y de la parrilla
					if (typeof data.callback === 'function') {
						data.callback()
						context.commit('BORRA_SELECCION_INSERCIONES')
					} else {
						context.commit('SET_INSERCIONES_PARRILLA', res.data.parrilla)
						context.commit('ACTUALIZA_BLOQUE', res.data.bloque)
						context.commit('BORRA_SELECCION_INSERCIONES')
					}
				})
				.catch(e => {
					this.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: 'Error programando los objetos'
					})
				})
		},
		// Desprograma inserciones en la parrilla activa
		desprogramarInserciones (context, data) {
			if (!Array.isArray(data) || data.length === 0) {
				this.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'Tienes que seleccionar las inserciones a eliminar'
				})
				return
			}

			const datos = {
				ProgramacionesID: data.map(p => p.ProgramacionID),
				BloqueID: context.getters.bloqueActivo.BloqueID,
				dia: context.state.filtro.dia
			}

			axios.post('organizar-emisoras/php/api/desprogramar-objetos.php', datos)
				.then(res => {
					if (typeof data.callback === 'function') {
						data.callback()
						context.commit('BORRA_SELECCION_INSERCIONES')
					} else {
						context.commit('SET_INSERCIONES_PARRILLA', res.data.parrilla)
						context.commit('ACTUALIZA_BLOQUE', res.data.bloque)
						context.commit('BORRA_SELECCION_INSERCIONES')
					}
				})
				.catch(e => {
					this.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: 'Error eliminando la programación'
					})
				})
		}
	}
}



// WEBPACK FOOTER //
// ./src/modulos/organizar-emisoras/vue/store.js